import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { SecurityService } from '../../../services/security.service';
import { PreferencesService } from '../../../services/preferences/preferences.service';

export const W8BEN_CONFIGURATION = new InjectionToken<boolean>('w8BenConfiguration');

export interface W8BenConfiguration {
  enabled: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class W8BenFormInitService {

  get w8benEnabled(): boolean {
    return Boolean(this.w8BenConfiguration?.enabled) &&
           this.hasPermission() &&
           this.hasUserPreference();
  }

  get initialModalEnabled(): boolean {
    return this.w8benEnabled;
  }

  constructor(@Optional() @Inject(W8BEN_CONFIGURATION)
              private w8BenConfiguration: W8BenConfiguration,
              private securityService: SecurityService,
              private preferencesService: PreferencesService) { }

  private hasPermission(): boolean {
    return this.securityService.hasPermission('W8_BEN') || this.securityService.hasPermission('W8_BEN_LITE');
  }

  private hasUserPreference(): boolean {
    return this.preferencesService.getPreloadedUserPreference<boolean>('W8BEN_INDICATOR') ?? false;
  }
}
